<div class="responsive-grid">
    <!-- autocomplete -->
    <!-- This autocomplete intentionally simple. It doesn't update if you change the address elsewhere. -->
    <!-- It does not submit if you hit enter. -->
    <div *ngIf="showAutocomplete" class="row">
        <mat-form-field>
            <mat-label>{{ autocompleteLabel ?? 'address.autocomplete' | translate }}</mat-label>
            <input
                matInput
                appAddressAutoComplete
                type="text"
                placeholder="{{ 'address.autocompletePlaceholder' | translate }}"
                name="street_address"
                (onAddressChange)="handleAddressChange($event)"
                (keydown.enter)="$event.preventDefault()"
            />
        </mat-form-field>
    </div>
    <div class="row">
        <!-- country -->
        <!-- Other fields will change depending on wether or not the user selects Canada.-->
        <mat-form-field>
            <mat-label>{{ 'address.country' | translate }}</mat-label>
            <ui-country-autocomplete
                placeholder="{{ 'address.countryPlaceholder' | translate }}"
                name="countryName"
                #country="ngModel"
                [required]="true"
                [(ngModel)]="address.country"
            ></ui-country-autocomplete>
            <mat-error *ngIf="country.invalid">{{ country.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- state/province -->
        <mat-form-field>
            <mat-label>{{ 'address.provinceState' | translate }}</mat-label>
            <ui-state-autocomplete
                placeholder="{{ 'address.provinceStatePlaceholder' | translate }}"
                name="provinceName"
                #province="ngModel"
                [required]="true"
                [country]="address.country"
                [(ngModel)]="address.province"
            >
            </ui-state-autocomplete>
            <mat-error *ngIf="province.invalid">{{ province.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <!-- postal code for canadians -->
        <!-- our backend will check that this matches the province -->
        <mat-form-field *ngIf="address.country === 'Canada'">
            <mat-label>{{ 'address.postalCode' | translate }}</mat-label>
            <input
                matInput
                type="text"
                required
                name="postalCode"
                #postal="ngModel"
                [(ngModel)]="address.postalCode"
                [textMask]="postalCodeMask"
                placeholder="{{ 'address.postalZipCodePlaceholder' | translate }}"
            />
            <mat-error *ngIf="postal.invalid">{{ postal.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- zip or postal code for non canadians -->
        <mat-form-field *ngIf="address.country !== 'Canada'">
            <mat-label>{{ 'address.postalZipCode' | translate }}</mat-label>
            <input
                matInput
                type="text"
                required
                name="postalCode"
                #postal="ngModel"
                [(ngModel)]="address.postalCode"
                placeholder="{{ 'address.postalZipCodePlaceholder' | translate }}"
            />
            <mat-error *ngIf="postal.invalid">{{ postal.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- city -->
        <mat-form-field>
            <mat-label>{{ 'address.city' | translate }}</mat-label>
            <input
                matInput
                type="text"
                required
                #city="ngModel"
                name="city"
                [(ngModel)]="address.city"
                placeholder="{{ 'address.cityPlaceholder' | translate }}"
            />
            <mat-error *ngIf="city.invalid">{{ city.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <!-- street address -->
        <mat-form-field>
            <mat-label>{{ 'address.streetAddress' | translate }}</mat-label>
            <input
                matInput
                type="text"
                required
                #addressLine1="ngModel"
                name="addressLine1"
                [(ngModel)]="address.addressLine1"
                placeholder="{{ 'address.streetAddressPlaceholder' | translate }}"
            />
            <mat-error *ngIf="addressLine1.invalid">{{ addressLine1.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- unit -->
        <mat-form-field>
            <mat-label>{{ 'address.unitSuite' | translate }}</mat-label>
            <input
                matInput
                type="text"
                #addressLine2="ngModel"
                name="addressLine2"
                [(ngModel)]="address.addressLine2"
                placeholder="{{ 'address.unitSuitePlaceholder' | translate }}"
            />
            <mat-error *ngIf="addressLine2.invalid">{{ addressLine2.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</div>
